export default __webpack_public_path__ + "static/media/not_data_find.40286c69.png";